import { Component } from '@angular/core';

import { ErrorModel } from '../../../shared/models/error.model';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { CopyService } from '../../../shared/services/copies/copy.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';

/**
 * Configuración predeterminada del componente
 *
 * *Default component settings*
 */
@Component({
  selector: 'app-document-scan-success',
  templateUrl: './document-scan-success.component.html',
  styleUrls: ['./document-scan-success.component.scss'],
})

/**
 * Definición de la clase DocumentScanSuccessComponent, escaneo del documento exítoso
 *
 * *Defines DocumentScanSuccessComponent class, document scan success*
 */
export class DocumentScanSuccessComponent {
  /**
   * Instancia de errorInfo como ErrorModel, errores ocurridos en el componente
   *
   * *errorInfo instance as ErrorModel, errors that occured in the app*
   *
   * @type {ErrorModel}
   */
  errorInfo = new ErrorModel();

  /**
   * Definición de la variable biometricsInfo que registra la información biométrica del usuario
   *
   * *Defines biometricsInfo variable that saves user biometrics info*
   *
   * @type {any}
   */
  biometricsInfo: any;

  /**
   * Summary Constructor of the component.
   *
   * @param {CopyService}        copyService        Injectable copyService service.
   * @param {NavigationService}  navigationService  Injectable navigationService service.
   * @param {AbreCuentasService} abreCuentasService Injectable abreCuentasService service.
   */
  constructor(
    public copyService: CopyService,
    private abreCuentasService: AbreCuentasService,
    private navigationService: NavigationService,
    private bitacoraService: BitacoraService,
    private headerService: HeaderService,
  ) {
    this.headerService.show(false, false, false);
  }

  /**
   * Siguiente paso una vez los datos biométricos fueron capturados
   *
   * *Next step once biometrics info was captured*
   */
  next() {
    const bitacoraEvent = 'frontdocumentScan_success';
    this.biometricsInfo = this.abreCuentasService.getProspectResponse();
    if (this.biometricsInfo && this.biometricsInfo.pep) {
      this.navigationService.nextStep('105');
    } else {
      this.bitacoraService.saveDataInBitacora(bitacoraEvent);
      this.navigationService.nextStep();
    }
  }
}
